import {
  getFromLocalStorage,
  setToLocalStorage,
  parseQueryString,
  removeFromLocalStorage,
} from './util';
import { ChannelCacheKey, DefaultChannel, NSFWCacheKey } from '@common/config';

const AppChannel = (function () {
  const { cid, pid } = parseQueryString(window.location.search);
  const ocid = getFromLocalStorage(ChannelCacheKey);
  const c = cid || pid || ocid || DefaultChannel;
  if (c !== ocid) {
    removeFromLocalStorage(NSFWCacheKey);
    setToLocalStorage(ChannelCacheKey, c);
  }
  return c;
})();

export default AppChannel;
